import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { PRODUCTS } from "@/lib/constants";

export default function CoverageCards() {
    return (
        <section
            id="coverage-cards"
            className="mm-section bg-mm-bg"
            data-testid="coverage-cards"
        >
            <div className="mm-container">
                <div className="mb-12 max-w-2xl">
                    <div className="mm-eyebrow mb-3">Solutions</div>
                    <h2 className="mm-display text-4xl sm:text-5xl text-mm-navy">
                        Eight lines of coverage — one advisor.
                    </h2>
                    <p className="mt-4 text-mm-muted">
                        Independent means we can match you across the right carrier for
                        your situation, not the one with the biggest spiff.
                    </p>
                </div>

                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                    {PRODUCTS.map((p, i) => {
                        const Icon = p.icon;
                        return (
                            <motion.div
                                key={p.key}
                                initial={{ opacity: 0, y: 16 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.2, margin: "0px 0px -80px 0px" }}
                                transition={{ duration: 0.45, delay: Math.min(i, 2) * 0.05 }}
                                className="mm-card group relative flex h-full flex-col p-6 transition-shadow duration-300 hover:shadow-hover"
                                data-testid={`coverage-card-${p.key.toLowerCase().replace(/[^a-z]/g, "-")}`}
                            >
                                <div className="mb-5 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-mm-navy to-mm-blue text-white">
                                    <Icon size={20} />
                                </div>
                                <h3 className="mm-display text-xl font-semibold text-mm-navy">
                                    {p.title}
                                </h3>
                                <p className="mt-2 flex-1 text-sm text-mm-muted leading-relaxed">
                                    {p.short}
                                </p>
                                <Link
                                    to={`/coverage#${p.key.toLowerCase().replace(/[^a-z]/g, "-")}`}
                                    className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-mm-navy hover:text-mm-blue"
                                >
                                    Learn more
                                    <ArrowUpRight
                                        size={14}
                                        className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                                    />
                                </Link>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
